import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconArContacts: React.FC<IconProps> = ({
  size = 15,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 15 16"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path d="M7.16602 7.3584C7.37963 7.3586 7.55254 7.53248 7.55273 7.74609C7.55273 7.95988 7.37975 8.13359 7.16602 8.13379C3.63686 8.134 0.775585 10.9953 0.775391 14.5244V14.7178C0.775352 14.9316 0.601578 15.1055 0.387695 15.1055C0.173989 15.1053 3.85896e-05 14.9315 0 14.7178V14.5244C0.000194845 10.5674 3.20905 7.35861 7.16602 7.3584ZM12.5859 8.9082C13.6553 8.9082 14.5232 9.77539 14.5234 10.8447V13.1689C14.5233 14.2384 13.6554 15.1055 12.5859 15.1055H8.71289C7.6438 15.1051 6.77651 14.2381 6.77637 13.1689V10.8447C6.77659 9.77564 7.64385 8.90862 8.71289 8.9082H12.5859ZM7.55176 11.6191V13.1689C7.5519 13.8103 8.07162 14.3306 8.71289 14.3311H12.5859C13.2276 14.3311 13.7479 13.8105 13.748 13.1689V11.6191H7.55176ZM8.71289 9.68359C8.07199 9.68401 7.55251 10.2029 7.55176 10.8438H13.748C13.7473 10.2027 13.2272 9.68359 12.5859 9.68359H8.71289ZM7.16406 0C9.08892 0.000140167 10.6501 1.56052 10.6504 3.48535L10.6455 3.66504C10.5522 5.50681 9.02898 6.97154 7.16406 6.97168L6.98535 6.9668C5.14346 6.87354 3.67871 5.35041 3.67871 3.48535C3.67899 1.56059 5.23929 0.000244514 7.16406 0ZM7.16406 0.774414C5.6671 0.774659 4.45341 1.9884 4.45312 3.48535C4.45312 4.98254 5.66693 6.19702 7.16406 6.19727C8.66129 6.19713 9.87598 4.98261 9.87598 3.48535C9.87569 1.98834 8.66111 0.774554 7.16406 0.774414Z" fill="currentColor"/>
  </svg>
);

export default IconArContacts;
